import { SVGProps } from '@components/Icon/types';

export const Form = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(4, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40039 13.5C5.22856 13.5002 5.90026 14.1718 5.90039 15C5.90039 15.8283 5.22864 16.4998 4.40039 16.5C3.57196 16.5 2.90039 15.8284 2.90039 15C2.90052 14.1717 3.57204 13.5 4.40039 13.5ZM4.40039 14.5C4.12433 14.5 3.90052 14.724 3.90039 15C3.90039 15.2761 4.12425 15.5 4.40039 15.5C4.67635 15.4998 4.90039 15.276 4.90039 15C4.90026 14.7241 4.67627 14.5002 4.40039 14.5Z"
        fill={fill}
      />
      <path
        d="M12.2646 14.3037C12.6199 14.304 12.9002 14.605 12.9004 14.9658C12.9 15.3265 12.6198 15.6276 12.2646 15.6279H7.7041C7.34868 15.6279 7.06871 15.3267 7.06836 14.9658C7.06858 14.6049 7.3486 14.3037 7.7041 14.3037H12.2646Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40039 9.5C5.22864 9.50021 5.90039 10.1717 5.90039 11C5.90039 11.8283 5.22864 12.4998 4.40039 12.5C3.57196 12.5 2.90039 11.8284 2.90039 11C2.90039 10.1716 3.57196 9.5 4.40039 9.5ZM4.40039 10.5C4.12425 10.5 3.90039 10.7239 3.90039 11C3.90039 11.2761 4.12425 11.5 4.40039 11.5C4.67635 11.4998 4.90039 11.276 4.90039 11C4.90039 10.724 4.67635 10.5002 4.40039 10.5Z"
        fill={fill}
      />
      <path
        d="M12.2646 10.3438C12.6199 10.3441 12.9002 10.6451 12.9004 11.0059C12.9 11.3665 12.6198 11.6676 12.2646 11.668H7.7041C7.34869 11.668 7.06873 11.3667 7.06836 11.0059C7.06858 10.6449 7.3486 10.3438 7.7041 10.3438H12.2646Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40039 5.5C5.22864 5.50021 5.90039 6.1717 5.90039 7C5.90039 7.8283 5.22864 8.49979 4.40039 8.5C3.57196 8.5 2.90039 7.82843 2.90039 7C2.90039 6.17157 3.57196 5.5 4.40039 5.5ZM4.40039 6.5C4.12425 6.5 3.90039 6.72386 3.90039 7C3.90039 7.27614 4.12425 7.5 4.40039 7.5C4.67635 7.49979 4.90039 7.27601 4.90039 7C4.90039 6.72399 4.67635 6.50021 4.40039 6.5Z"
        fill={fill}
      />
      <path
        d="M12.2646 6.37988C12.6201 6.38021 12.9002 6.68179 12.9004 7.04297C12.9 7.40404 12.62 7.70573 12.2646 7.70605H7.7041C7.3485 7.70605 7.0687 7.40423 7.06836 7.04297C7.06858 6.6816 7.34842 6.37989 7.7041 6.37988H12.2646Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6318 0C11.1749 0 11.6563 0.269166 11.9326 0.672852H13.5801C14.9194 0.672852 15.9998 1.6888 16 2.9502V17.7227C15.9997 18.984 14.9194 20 13.5801 20H2.41992C1.08062 20 0.000265594 18.984 0 17.7227V2.9502C0.000160768 1.71645 1.03338 0.717983 2.33203 0.674805L4.06445 0.677734C4.34027 0.271404 4.82297 0 5.36816 0H10.6318ZM2.41992 1.94531C1.82377 1.94531 1.35172 2.39002 1.35156 2.9502V17.7227C1.35182 18.2828 1.82383 18.7275 2.41992 18.7275H13.5801C14.1762 18.7275 14.6482 18.2828 14.6484 17.7227V2.9502C14.6483 2.39002 14.1762 1.94531 13.5801 1.94531H12.1797V2.55273C12.1797 3.35395 11.481 4.0127 10.6318 4.0127H5.36816C4.51897 4.0127 3.82129 3.35395 3.82129 2.55273V1.94434L2.41992 1.94531ZM5.36816 1.19824C5.36816 1.19824 5.26284 1.18155 5.13281 1.26758C5.00762 1.35051 5.00309 1.45187 5.00293 1.45898V2.55273C5.00293 2.55273 5.00291 2.66179 5.08203 2.72559C5.22217 2.83854 5.36816 2.81445 5.36816 2.81445H10.6318C10.6318 2.81445 10.7372 2.83017 10.8672 2.74414C10.9969 2.65815 10.9971 2.55273 10.9971 2.55273V1.45898C10.997 1.45174 10.9942 1.34866 10.918 1.28711C10.7778 1.17415 10.6318 1.19824 10.6318 1.19824H5.36816Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'clipboard-form';
